import classes from './app-shell.module.css'

const AppShell = {
  classNames: {
    root: classes.root,
    navbar: classes.panel,
    header: classes.panel,
    aside: classes.panel,
    footer: classes.panel,
  },
}

export default AppShell
